import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import ModalBottomSheet from "@/components/ui/modals/ModalBottomSheet";
import ModalCenterSheet from "@/components/ui/modals/ModalCenterSheet";
import DeleteAccountModalContent from "../ui/DeleteAccountModalContent";
import PermissionAlert from "../ui/PermissionAlert";
import { ModalType } from "../types/ModalTypes";
import { MODAL_ANIMATION } from "../constants/animations";
import { ModalContent } from "./ModalContent";

interface ModalsProps {
  isBottomSheetOpen: boolean;
  isCenterSheetOpen: boolean;
  isVisiblePermissionAlert: boolean;
  modalType: ModalType;
  closeBottomSheet: () => void;
  closeCenterSheet: () => void;
  closePermissionAlert: () => void;
  openOnDeleteAccountAlert: () => void;
  deleteAccount: (text: string) => void;
  openBottomSheet: (type: ModalType) => void;
  logout: () => void;
  userInfo: any;
  subscription: any;
  navigateToAstrologChanel: () => void;
  navigateToDeveloperChanel: () => void;
  isPushNotificationEnabled: boolean;
  handleEnableNotifications: () => void;
  aboutText: string;
  navigateToSubscription: () => void;
}

export const Modals: React.FC<ModalsProps> = ({
  isBottomSheetOpen,
  isCenterSheetOpen,
  isVisiblePermissionAlert,
  modalType,
  closeBottomSheet,
  closeCenterSheet,
  closePermissionAlert,
  openOnDeleteAccountAlert,
  deleteAccount,
  openBottomSheet,
  logout,
  userInfo,
  subscription,
  navigateToAstrologChanel,
  navigateToDeveloperChanel,
  isPushNotificationEnabled,
  handleEnableNotifications,
  aboutText,
  navigateToSubscription
}) => (
  <>
    <ModalBottomSheet open={isBottomSheetOpen} onClose={closeBottomSheet}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={modalType}
          {...MODAL_ANIMATION}
          className="w-full"
        >
          <ModalContent
            modalType={modalType}
            onNavigateToProfile={() => openBottomSheet(ModalType.Profile)}
            onNavigateToAbout={() => openBottomSheet(ModalType.About)}
            onBackToSettings={() => openBottomSheet(ModalType.Settings)}
            navigateToAstrologChanel={navigateToAstrologChanel}
            navigateToDeveloperChanel={navigateToDeveloperChanel}
            isPushNotificationEnabled={isPushNotificationEnabled}
            handleEnableNotifications={handleEnableNotifications}
            logout={logout}
            userInfo={userInfo}
            subscription={subscription}
            onDelete={openOnDeleteAccountAlert}
            aboutText={aboutText}
            navigateToSubscription={navigateToSubscription}
          />
        </motion.div>
      </AnimatePresence>
    </ModalBottomSheet>

    <ModalCenterSheet open={isCenterSheetOpen} onClose={closeCenterSheet}>
      <DeleteAccountModalContent
        onCancel={closeCenterSheet}
        onDelete={deleteAccount}
      />
    </ModalCenterSheet>

    <ModalCenterSheet open={isVisiblePermissionAlert} onClose={closePermissionAlert}>
      <PermissionAlert onCancel={closePermissionAlert} />
    </ModalCenterSheet>
  </>
); 